  export const base64ToImageFile = (base64) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);

        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "image.jpg", { type: blob.type });
            resolve(file);
          }
        }, "image/jpeg", 1.0);
      };
       img.src = base64;
    });
  };

